import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";

import { AngularFireRemoteConfig } from '@angular/fire/remote-config';
import { IData } from 'src/app/models/interfaces/idata';
import * as vendorConfig from './../../../environments/vendor.config.json';
import { UtilityService } from '../utility.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private _config: any = undefined;

  constructor(private remoteConfig: AngularFireRemoteConfig, private utilityService: UtilityService) { }

  async setup(): Promise<void> {
    if (!this._config) {
      try {
        await this.remoteConfig.fetchAndActivate();

        let configName = environment.firebaseConfigParam;
        const localeInfo = this.utilityService.getLocaleInfo();
        if (!localeInfo.isUnitedStatesStandardEnglishLocale || localeInfo.countryCode != "us") {
          configName = `${configName}_${localeInfo.localeName}`;
        }
        const remoteConfigValue = await this.remoteConfig.getValue(configName);
        this._config = JSON.parse((remoteConfigValue as IData)["_value"]);
      } catch (error) {
        console.error(error);
        this._config = (vendorConfig as IData)["default"];
      }
    }
  }

  getString(fieldName: string): string {
    return this.getValue(fieldName) as string;
  }

  getNum(fieldName: string): number {
    return this.getValue(fieldName) as number;
  }

  getBool(fieldName: string): boolean {
    return this.getValue(fieldName) as boolean;
  }

  getStringArray(fieldName: string): string[] {
    return this.getValue(fieldName) as string[];
  }

  getValue(fieldName: string): any {
    const vendorConfigContent = (vendorConfig as IData)["default"];

    if (this._config) {
      return this._config[fieldName] ?? vendorConfigContent[fieldName];
    }

    return vendorConfigContent[fieldName];
  }

  // in the config there are several pairs of fields that are associated i.e. title & subtitle, brand data source name & display name
  // this function will find the related field given some initial info about the 2 fields
  getRelatedFieldFromConfig(sourceFieldValue: string, sourceFieldIdentifier: string, relatedFieldIdentifier: string): string {
    let relatedFieldValue: string = "";

    const configContent = (this._config as IData) ? (this._config as IData) : (vendorConfig as IData)["default"];

    for (const property in configContent) {
      if ((configContent as IData)[property] === sourceFieldValue) {
        const sourceFieldName = property;

        const relatedFieldName = sourceFieldName.replace(sourceFieldIdentifier, relatedFieldIdentifier);
        relatedFieldValue = (configContent as IData)[relatedFieldName];
      }
    }

    return relatedFieldValue;
  }
}
